import { Route, Routes } from "react-router-dom";
import CompanyUserSetting from "pages/management/setting/company/company";
import CompanyUserModifySetting from "pages/management/setting/company/company-modify";
import CompanyUserAddSetting from "pages/management/setting/company/company-add";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";

export default function MonitoringSettingCompanyRoutes(props) {

    return (
        <Routes>
            <Route path="/">
                <Route index 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_COMPANY_USER_READ}
                        >
                            <CompanyUserSetting />
                        </PermissionRoute>
                    }
                />
                <Route path="modify/:id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_COMPANY_USER_READ}
                        >
                            <CompanyUserModifySetting />
                        </PermissionRoute>
                    }
                />
                <Route path="add" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.SETTING_COMPANY_USER_READ}
                        >
                            <CompanyUserAddSetting />
                        </PermissionRoute>
                    }
                />
                <Route path="*" element={ <RouteAccessError/> }/>
            </Route>
        </Routes>
    );
}